import { useState, useEffect } from 'react';

/**
 * @deprecated Use "useInterval" instead
 */
const useActionPolling = (rate: number) => {
  const [pollingInterval, setPollingInterval] = useState(-9999);
  const [pollableActions, setPollableActions] = useState(new Map());

  const pollRate = rate || 500;

  const addPollableAction = (name: string, action: () => void) => {
    setPollableActions(new Map(pollableActions.set(name, action)));
  };

  const removePollableAction = (name: string) => {
    pollableActions.delete(name);
    setPollableActions(new Map(pollableActions));
  };

  const stopPolling = () => {
    clearInterval(pollingInterval);
  };

  useEffect(() => {
    if (pollableActions.size > 0) {
      const timeoutId = window.setTimeout(executeTick, pollRate);
      setPollingInterval(timeoutId);
    } else {
      clearTimeout(pollingInterval);
    }

    return () => stopPolling();
  }, [pollableActions]);

  const executeTick = () => {
    const timeoutId = window.setTimeout(executeTick, pollRate);

    // Call actions that should be polled
    pollableActions.forEach((action: () => void) => {
      action();
    });

    setPollingInterval(timeoutId);
  };

  return {
    addPollableAction,
    removePollableAction,
    stopPolling,
  };
};

export default useActionPolling;
